package ui.composables

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyListScope
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import ui.theme.ColorScheme

/**
 * Helper [LazyListScope] item with background color applied as surface
 */
fun LazyListScope.surfaceItem(
    showGalleryBg: Boolean = true,
    modifier: Modifier = Modifier,
    maxContentWidth: Dp = 620.dp,
    content: @Composable BoxScope.() -> Unit,
) {
    item(contentType = "surface") {
        val colorBg = if (showGalleryBg) {
            ColorScheme.surface.copy(alpha = 0.7f)
        } else {
            ColorScheme.surface
        }

        Box(
            modifier
                .background(colorBg)
                .fillMaxWidth(),
            contentAlignment = Alignment.Center
        ) {
            Box(Modifier.widthIn(max = maxContentWidth)) {
                content()
            }
        }
    }
}